import util from '../../../../share/util/utils';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import DmDataPointConversion from "../../dataMonitor/dmDataPointConversion";
import dmUtil from "../../dataMonitor/dataMonitorUtil";
import { RANGE } from "../../dataMonitor/ConfigureGraph";
import { fixNumberWithDecimal } from "@/common/nodejs/mathFunctions";
import dmDidDataConversion from "../../../../share/util/didDataConversion";

// PID/DID設定情報
const WS45_DATA_MONITOR_SETTINGS = {
  // エバポシステム圧力（絶対圧）
  "53_1_all": { sort_id: 1, is_default_graph_show: true, is_obd: true, is_data_monitor_show: true },
  // ELCMポンプ
  "1273_1_all": { sort_id: 2, is_default_graph_show: true, is_obd: false, is_data_monitor_show: true },
  // ELCM切替弁
  "1272_1_all": { sort_id: 3, is_default_graph_show: true, is_obd: false, is_data_monitor_show: true },
  // エバポパージ
  "F42E_1_all": { sort_id: 4, is_default_graph_show: true, is_obd: true, is_data_monitor_show: true },
  // CPCソレノイド2
  "11F0_1_all": { sort_id: 5, is_default_graph_show: true, is_obd: false, is_data_monitor_show: true },
  // 密閉弁出力
  "13A7_1_all": { sort_id: 6, is_default_graph_show: true, is_obd: false, is_data_monitor_show: true },
  // タンク内圧
  "13A6_1_all": { sort_id: 7, is_default_graph_show: true, is_obd: false, is_data_monitor_show: true },
  // エバポパージ
  "2E_1_all": { sort_id: 8, is_default_graph_show: true, is_obd: true, is_data_monitor_show: true },
  // ECU電源電圧
  "42_1_all": { sort_id: 9, is_default_graph_show: false, is_obd: true, is_data_monitor_show: true },
  // エンジン水温
  "05_1_all": { sort_id: 10, is_default_graph_show: false, is_obd: true, is_data_monitor_show: true },
  // 吸気温度
  "0F_1_all": { sort_id: 11, is_default_graph_show: false, is_obd: true, is_data_monitor_show: true },
  // 吸気温センサ #11
  "68_2_all": { sort_id: 12, is_default_graph_show: false, is_obd: true, is_data_monitor_show: true },
  // (68_2_all 表示判定用)
  "68_1_0": { sort_id: 0, is_default_graph_show: false, is_obd: true, is_data_monitor_show: false },
  // エンジン油温
  "5C_1_all": { sort_id: 13, is_default_graph_show: false, is_obd: true, is_data_monitor_show: true },
  // 燃料レベル
  "2F_1_all": { sort_id: 14, is_default_graph_show: false, is_obd: true, is_data_monitor_show: true },
  // エバポシステム圧力（絶対圧）
  "F453_1_all": { sort_id: 1, is_default_graph_show: true, is_obd: true, is_data_monitor_show: true },
  // ECU電源電圧
  "F442_1_all": { sort_id: 8, is_default_graph_show: false, is_obd: true, is_data_monitor_show: true },
  // エンジン水温
  "F405_1_all": { sort_id: 9, is_default_graph_show: false, is_obd: true, is_data_monitor_show: true },
  // 吸気温度
  "F40F_1_all": { sort_id: 10, is_default_graph_show: false, is_obd: true, is_data_monitor_show: true },
  // 吸気温センサ #11
  "F468_2_all": { sort_id: 11, is_default_graph_show: false, is_obd: true, is_data_monitor_show: true },
  // エンジン油温
  "F45C_1_all": { sort_id: 12, is_default_graph_show: false, is_obd: true, is_data_monitor_show: true },
  // 燃料レベル
  "F42F_1_all": { sort_id: 13, is_default_graph_show: false, is_obd: true, is_data_monitor_show: true },
  // 以下表示対象外
  "87_2_all": { sort_id: 0, is_default_graph_show: false, is_obd: true, is_data_monitor_show: false },
  "0B_1_all": { sort_id: 0, is_default_graph_show: false, is_obd: true, is_data_monitor_show: false },
  "33_1_all": { sort_id: 0, is_default_graph_show: false, is_obd: true, is_data_monitor_show: false },
  "F487_2_all": { sort_id: 0, is_default_graph_show: false, is_obd: true, is_data_monitor_show: false },
  "F40B_1_all": { sort_id: 0, is_default_graph_show: false, is_obd: true, is_data_monitor_show: false },
  "F433_1_all": { sort_id: 0, is_default_graph_show: false, is_obd: true, is_data_monitor_show: false },
};

// PID/DID表取り込み
const conversionInformation = require('../../../../../src/data/wsp/DataMonitorConversionInfo.json');

// PID0x53グラフ表示デフォルト範囲算出用係数マップ
const PSI_UNIT_SCALING_FACTOR_MAP = {
  unitId_3: 6.8966,   // kPa
  unitId_56: 51.7310, // mmHg
  unitId_22: 2.0344,  // inHg
  unitId_21: 1.0000,  // psi
  unitId_26: 27.6897, // inH2O
};

// PID0x53参照ID探索用マップ
const FACTOR_ID_MAP = {
  4501: ["87_2_all", "0B_1_all", "33_1_all"],
  12501: ["F487_2_all", "F40B_1_all", "F433_1_all"]
};

/**
 * DataMonitor関連処理
 */
export default class DataMonitor {

  constructor(self, calledFrom) {
    // 呼び出し元インスタンス
    this.requirementInstance = self;
    // データ再生機能からの呼び出しかどうか
    this.isPlay = calledFrom === "play" ? true : false;
    // 文言表示用
    this.specifiedSystemId = "";
    this.region = individualDiagnose.getRegion(self);
    // データポイントインスタンス生成
    this.dataConversion = new DmDataPointConversion();
    // マーカー機能で使用するObjectを定義
    this.ws45MarkerInfo = {
      projectId: self.projectId,
      baseTime: null,
      measuredTimes: [],
      isPlay: this.isPlay
    };
    // 初期化
    this.initialize();
    this.workSupportId = self.workSupportId;
    //  データモニタprop(定数)
    this.inExecution = true;
    this.inPlaying = false;
    this.measurementUuid = "";
    this.apiToken = "";
    this.endpoint = "";
    this.highlightItems = [];
    this.dataMonitorFunctionSettings = new dmUtil.DataMonitorFunctionSettings(
      this.isPlay ? dmUtil.TYPE_CALLER.PLAY_WS45 : dmUtil.TYPE_CALLER.WS45
    ); // DM機能の設定インスタンス
    this.savedMarkerInfo = [];
    this.isCompleted = false;
    this.checkLines = null;
  }

  completeResolve() { }

  // 変数初期化
  initialize() {
    this.isStartToggle = this.isInterruption = this.dataMonitorShow = false;
    this.isEndToggle = true;
    this.dataMonitorPhase = '';
    this.dataMonitorTemporaryResponse
      = this.dataMonitorList
      = this.selectedFuncs
      = this.displayTargets
      = this.ws45MarkerInfo.measuredTimes
      = [];
    this.conversionList = this.selectedFunctionHash = this.funcValues = {};
    this.graphConfigInfo = {
      xRange: 1,
      yRange: {},
      lineSetting: {}
    };
    this.baseTime = this.ws45MarkerInfo.baseTime = null;
    this.getMeasuredDataNumber = 0;
    this.dataConversion.clear();
  }

  /**
   * データモニタ―表示 作成/更新
   * @param {object} monitorItems 計測データ取得monitor_items
   * @param {number} timestamp 計測データ取得timestamp
   */
  async update(monitorItems, timestamp) {
    // マーク機能用timestamp配列更新
    this.ws45MarkerInfo.measuredTimes.push(Number(timestamp));
    // 表示対象のみにフィルタ
    this.displayTargets = monitorItems.filter(item => {
      const itemId = item?.id || item?.data_monitor_id;
      if (["68_2_all", "F468_2_all"].includes(itemId)) {
        const showBit = monitorItems.find(element => {
          const showId = element?.id || element?.data_monitor_id;
          return ["68_1_0", "F468_1_0"].includes(showId);
        });
        // WS.45/125とデータ再生ではmonitorItemsの構造が異なる。
        // WS.45/125ではshowBit.valueを評価し、データ再生としてshowBit.data_records[0]?.converted_dataを評価する
        return showBit
          ? this.isPlay
            ? showBit.data_records[0]?.converted_data === "FF"
            : showBit.value === "FF"
          : false;
      }
      return Object.keys(WS45_DATA_MONITOR_SETTINGS).includes(itemId)
        ? WS45_DATA_MONITOR_SETTINGS[itemId].is_data_monitor_show
        : false;
    });
    this.displayTargets = this.displayTargets.map(item => {
      const dataMonitorId = this.isPlay ? item.data_monitor_id : item.id;
      return {
        ...item,
        data_monitor_id: dmUtil.setSystem(this.specifiedSystemId, dataMonitorId)
      };
    });

    // 2回目の計測後、選択タブを「結合グラフ」に変更(1回目は変更できないため)
    if (this.getMeasuredDataNumber === 1) {
      this.requirementInstance.$refs.data_monitor_measure.selectedTab = 2;
    }
    // 初回実行時のみ
    if (this.getMeasuredDataNumber === 0) {
      await this.dataMonitorInitialSequence(monitorItems, this.displayTargets);
    }
    /* dataMonitorList */
    if (this.isPlay) {
      this.dataMonitorList = this.getRecollectionDataMonitorList(this.displayTargets);
    } else {
      this.dataMonitorList = this.getDataMonitorList(this.displayTargets, timestamp);
    }
    /* funcValues */
    this.funcValues = this.getFuncValues(this.displayTargets);
    // 計測回数更新
    this.getMeasuredDataNumber++;
  }

  /** 
   * 初回計測時のみ実行
   * @param {array} monitorItems 計測データ
   * @param {array} displayTargets 計測データのうち表示対象のみ
   */
  async dataMonitorInitialSequence(monitorItems, displayTargets) {
    /* conversionList - did変換情報取得 */
    this.conversionList = await this.getConversionList(displayTargets);
    /* selectedFuncs - 表示項目一覧 */
    this.selectedFuncs = this.getSelectedFuncs(displayTargets);
    /* selectedFunctionHash */
    this.selectedFuncs.forEach(item => {
      this.selectedFunctionHash[item.data_monitor_id] = {
        sort_id: item.sort_id,
        menu_title: item.menu_title,
        pullDownVisible: item.pullDownVisible,
        selectItem: item.selectItem
      };
    });
    /* dataMonitorMeasureマウント */
    await this.requirementInstance.$nextTick(async () => {
      this.dataMonitorShow = true;
    });
    /* baseTime */
    if (this.isPlay) {
      const time = Math.floor(Number(displayTargets[0].data_records[0].time));
      this.baseTime = time;
      this.requirementInstance.$refs.data_monitor_measure.baseTime = time;
    } else {
      this.baseTime = this.requirementInstance.timestamp; // dataMonitorMeasure側でbaseOrgTimeのウォッチャを起動させるため
      this.requirementInstance.$refs.data_monitor_measure.baseTime = this.baseTime;
    }
    /* 結合グラフタブを表示 */
    this.requirementInstance.$refs.data_monitor_measure.currentTab = 2;
    /* デフォルトチェック項目 */
    await this.requirementInstance.$nextTick(async () => {
      for (let i = 0; i < this.selectedFuncs.length; i++) {
        // データ再生の場合システム名が含まれるため、idを取り出す
        const itemId = this.specifiedSystemId
          ? dmUtil.getNoSystemItemId(this.selectedFuncs[i].data_monitor_id)
          : this.selectedFuncs[i].data_monitor_id;
        if (WS45_DATA_MONITOR_SETTINGS[itemId].is_default_graph_show) {
          try {
            await this.requirementInstance.$refs.data_monitor_measure.changeCheckValue(1, true, i);
          } catch (error) {
            console.error("ChangeCheckValue Error:", error);
          }
        }
      }
    });
    await this.requirementInstance.$nextTick(async () => {
      Promise.all([
        /* すべての初期表示グラフRangeをデフォルト表示に変更 */
        this.setGraphRangeDefault(displayTargets),
        /* PID0x53のグラフ初期設定(表示対象外IDについても引数に含める) */
        this.setGraphConfig(monitorItems),
        this.requirementInstance.$nextTick(() => {
          // 表示情報更新
          this.requirementInstance.$refs.data_monitor_measure.handleConfigGraphComplete(this.graphConfigInfo);
        }),
        await this.requirementInstance.$nextTick(async () => {
          // 表示DB情報更新
          await this.requirementInstance.$refs.data_monitor_measure.handleOkConfigGraphModal(null, true);
        })
      ]);
    });
  }

  /**
   * conversionList取得
   * @param {array} monitorItems 計測データ取得結果monitor_items
   * @returns {object} conversionList
   */
  async getConversionList(monitorItems) {
    const monitorConversionList = {};
    monitorItems.forEach(item => {
      const itemId = this.isPlay
        ? dmUtil.getNoSystemItemId(item.data_monitor_id)
        : item.id;

      // start_byte_positionがid文字列内のインデックスと一致するものでフィルタリング
      const targetInfo = conversionInformation[itemId]?.info.find(element => {
        const index = itemId[2] === "_" ? 3 : 5; // PIDの場合は3、DIDの場合は5
        return parseInt(itemId[index], 10) === element.start_byte_position;
      });
      if (!targetInfo) return;
      monitorConversionList[item.data_monitor_id] = {
        byte_or_bit: targetInfo.byte_or_bit,
        start_byte_position: targetInfo.start_byte_position,
        byte_size: targetInfo.byte_size,
        start_bit_position: targetInfo.start_bit_position,
        bit_size: targetInfo.bit_size,
        signature: targetInfo.signature,
        data_type: item.data_type,
        unit: item.unit,
        data_monitor_display: true, // 固定
        data_monitor_display_analysis: false, // 固定
        ffd_display: true, // 固定
        ffd_display_analysis: false, // 固定
        ffd_control_history_display: false, // 固定
        ffd_control_history_display_analysis: false, // 固定
        digit_after_decimal: item.digits_after_decimal,
        graph_range_display: item.graph_range_display,
        monitor_display_order: WS45_DATA_MONITOR_SETTINGS[itemId].sort_id, // 固有ソート
        little_endian: false, // 固定
        time_format: { // 固定
          exist: false
        },
        unit_id: item.unit,
        unit_conversion: {},
        is_obd: WS45_DATA_MONITOR_SETTINGS[itemId].is_obd
      };
    });
    return monitorConversionList;
  }

  /**
   * selectedFuncs取得
   * @param {array} monitorItems 計測データ取得結果monitor_items
   * @returns {object} selectedFuncs
   */
  getSelectedFuncs(monitorItems) {
    const findFFDi18nKey = individualDiagnose.getFFDi18nKeyWithRegion(
      this.requirementInstance, this.region || this.requirementInstance.region, this.specifiedSystemId
    );
    const unsortedSelectedFuncs = monitorItems.map(item => {
      const itemId = item?.id ? item.id : dmUtil.getNoSystemItemId(item.data_monitor_id);
      let i18nDmItemKey = "";
      if (itemId[2] === "_") { // ID文字列において3文字目が"_"の場合
        // PID対応
        i18nDmItemKey = `pid.F4${itemId}`;
      } else if (WS45_DATA_MONITOR_SETTINGS[itemId].is_obd) { // DIDが4桁かつOBDの翻訳リソースを用いる場合
        i18nDmItemKey = `pid.${itemId}`;
      } else {
        i18nDmItemKey = `${findFFDi18nKey}.${itemId}`;
      }
      return {
        data_monitor_id: item?.data_monitor_id,
        sort_id: WS45_DATA_MONITOR_SETTINGS[itemId].sort_id,
        menu_title: util.trimStr(this.requirementInstance.$t(i18nDmItemKey)),
        pullDownVisible: true,
        selectItem: "1"
      };
    });
    return unsortedSelectedFuncs.sort((a, b) => {
      return a.sort_id - b.sort_id;
    });
  }

  /**
   * dataMonitorList取得
   * @param {array} monitorItems 計測データ取得結果monitor_items
   * @param {number} timestamp 計測データ取得結果timestamp
   * @returns {array} dataMonitorList
   */
  getDataMonitorList(monitorItems, timestamp) {
    const monitorList = [];
    monitorItems.forEach(item => {
      monitorList.push(
        [
          {
            data_monitor_id: item.data_monitor_id,
            convertedData: this.convertValue(item.value, item.data_monitor_id),
            time: Math.floor(timestamp)
          }
        ]
      );
    });
    return monitorList;
  }

  /**
   * dataMonitorList取得(データ再生用)
   * @param {array} monitorItems 計測データ取得結果monitor_items
   * @returns {array} dataMonitorList
   */
  getRecollectionDataMonitorList(monitorItems) {
    const monitorList = [];
    monitorItems.forEach((item) => {
      const id = item.data_monitor_id;
      const pre = [];
      item.data_records.forEach((record) => {
        pre.push(
          {
            data_monitor_id: id,
            convertedData: this.convertValue(record.converted_data, id),
            time: Number(record.time)
          }
        );
      });
      monitorList.push(pre);
    });
    return monitorList;
  }

  /**
   * funcValues取得
   * @param {monitorItems} monitorItems 計測データ取得monitor_items
   * @returns {object} funcValues
   */
  getFuncValues(monitorItems) {
    if (this.isPlay) {
      monitorItems.forEach(item => {
        item.data_records.forEach(record => {
          this.dataConversion.updateFuncValues(
            item.data_monitor_id,
            this.convertValue(record.converted_data, item.data_monitor_id),
            this.conversionList[item.data_monitor_id]
          );
        });
      });
    } else {
      monitorItems.forEach(item => {
        this.dataConversion.updateFuncValues(
          item.data_monitor_id,
          this.convertValue(item.value, item.data_monitor_id),
          this.conversionList[item.data_monitor_id]
        );
      });
    }
    return this.dataConversion.funcValues;
  }

  /**
   * 初期表示グラフRangeをAUTO表示に変更
   * @param {array} monitorItems 計測データ取得monitor_items
   */
  async setGraphRangeDefault(monitorItems) {
    // xRange
    this.graphConfigInfo.xRange = 1;
    // yRange
    monitorItems.forEach(item => {
      const itemId = item?.data_monitor_id;
      // デフォルトでグラフ表示する項目にのみ設定を行う
      if (!this.graphConfigInfo.yRange[itemId] && WS45_DATA_MONITOR_SETTINGS[dmUtil.getNoSystemItemId(itemId)]?.is_default_graph_show) {
        this.graphConfigInfo.yRange[itemId] = {
          selectedRange: RANGE.AUTO,
          min: this.conversionList[itemId].graph_range_display.min,
          max: this.conversionList[itemId].graph_range_display.max
        };
      }
    });
  }

  /**
   * PID0x53, DID0xF453のグラフ初期設定
   * @param {array} monitorItems 計測データ取得monitor_items
   */
  setGraphConfig(monitorItems) {
    // データ再生の場合は別メソッドを実行する
    if (this.isPlay) {
      this.setRecollectionGraphConfig(monitorItems, this.specifiedSystemId);
      return;
    }

    const [targetIdKey, factorIds] = (this.workSupportId === 4501)
      ? ["53_1_all", ["33_1_all", "0B_1_all", "87_2_all"]]
      : ["F453_1_all", ["F433_1_all", "F40B_1_all", "F487_2_all"]];
    const itemId = dmUtil.setSystem(this.specifiedSystemId, targetIdKey);
    if (itemId in this.graphConfigInfo.yRange) {
      // グラフ表示範囲を計算するための基準値を取得するため、FACTOR_ID_MAPに基づいて対象IDを探索
      let basisValue = null;
      let factorItem = {};
      for (let i = 0; i < factorIds.length; i++) {
        factorItem = monitorItems.find(item => item.id === factorIds[i]);
        if (factorItem) {
          basisValue = factorItem.value;
        }
      }
      if (basisValue !== null) {
        const targetItem = monitorItems.find(item => item.id === targetIdKey);
        // 独自のMIN/MAXの値をyRangeに保持
        this.graphConfigInfo.yRange[itemId].spMin = parseFloat(this.convertValue(basisValue - 1.5 * PSI_UNIT_SCALING_FACTOR_MAP[targetItem.unit], itemId), "Value");
        this.graphConfigInfo.yRange[itemId].spMax = parseFloat(this.convertValue(basisValue + 0.5 * PSI_UNIT_SCALING_FACTOR_MAP[targetItem.unit], itemId), "Value");
      }
    }
  }

  /**
   * PID0x53, DID0xF453のグラフ初期設定（データ再生用）
   * @param {array} monitorItems 計測データ取得monitor_items
   * @param {string} system システム名
   */
  setRecollectionGraphConfig(monitorItems, system) {
    // PID/DID キーを生成
    const pid0x53Key = dmUtil.setSystem(system, "53_1_all");
    const did0x53Key = dmUtil.setSystem(system, "F453_1_all");

    // yRange にキーが存在するか確認
    const targetKey = [pid0x53Key, did0x53Key].find(key => key in this.graphConfigInfo.yRange);
    if (!targetKey) return; // キーが存在しない場合は処理を終了

    // monitorItems にシステム情報を付加
    const monitorItemsWithSystem = monitorItems.map(item => ({
      ...item,
      data_monitor_id: dmUtil.setSystem(system, item.data_monitor_id)
    }));

    // 対象のアイテムを取得
    const pid0x53AcquiredItem = monitorItemsWithSystem.find(item => item.data_monitor_id === targetKey);
    if (!pid0x53AcquiredItem) return; // 対象アイテムが見つからない場合は処理を終了

    // グラフ表示範囲を計算するための基準値を取得するため、FACTOR_ID_MAPに基づいて対象IDを探索
    let basisValue = null;
    let filteredItem = [];
    // FACTOR_ID_MAP のすべての値を結合して配列を作成
    const allFactorIds = Object.values(FACTOR_ID_MAP).flat();
    const targetIds = allFactorIds.map(id => dmUtil.setSystem(system, id)); // プレフィックスを付加
    for (const targetId of targetIds) {
      // monitorItemsWithSystemの中からtargetIdと一致する要素を探す
      filteredItem = monitorItemsWithSystem.find(item => item.data_monitor_id === targetId);
      // 一致する要素が見つかった場合はその値を代入してループ終了
      if (filteredItem) {
        basisValue = filteredItem.data_records[0].converted_data;
        break;
      }
    }

    if (!basisValue) return; // basisValue が取得できない場合は処理を終了

    // スケーリングファクターを計算
    const scalingFactor = PSI_UNIT_SCALING_FACTOR_MAP[pid0x53AcquiredItem.unit] || 1;

    // 独自のMIN/MAXの値をyRangeに保持
    this.graphConfigInfo.yRange[targetKey].spMin = parseFloat(this.convertValue(basisValue - (1.5 * scalingFactor), pid0x53AcquiredItem.data_monitor_id), "Value");
    this.graphConfigInfo.yRange[targetKey].spMax = parseFloat(this.convertValue(basisValue + (0.5 * scalingFactor), pid0x53AcquiredItem.data_monitor_id), "Value");
  }

  /**
   * 表示値変換
   * @param {*} value 取得した値
   * @param {string} id データモニタID
   * @param {string} dataType データタイプ
   * @return {string} 表示値
   */
  convertValue(value, id, dataType = "") {
    if (dataType === "Value" || this.conversionList[id].data_type === "Value") {
      return fixNumberWithDecimal(value, this.conversionList[id].digit_after_decimal);
    } else {
      const byteDataList = [];
      if (this.conversionList[id].byte_or_bit === "byte") {
        for (let i = 0; i < value.length; i += 2) {
          byteDataList.push(parseInt(value.substring(i, i + 2), 16));
        }
      } else {
        byteDataList.push(...this.hexToDecimalArray(parseInt(value, 2).toString(16)));
      }

      // グラフに10進数値と変換値を渡すため、表示直前に変換を行えるようにバイト配列のまま返す
      return dmDidDataConversion.convertHexData(byteDataList);
    }
  }

  /**
   * 既に保存されているマーカーの設定
   * @param {array} comments マーカーのコメント情報
   * @param {string} userId ユーザーID
   */
  createMarkerDetails(comments, userId, baseTime = null) {
    const savedMarkerInfo = comments
      .filter(comment => comment.comment !== null)
      .map(comment => {
        return {
          uuid: String(comment.time),
          detail: {
            occurred_elapsed_time: (comment.time - (baseTime ? baseTime : this.baseTime)) * 1000
          },
          description: comment.comment,
          tag: { userId: userId, shared: String(comment.is_shared) }
        };
      });
    return savedMarkerInfo;
  }
}
